import clsx from 'clsx'
import type { ReactNode } from 'react'

import RatingDownIcon from '@/assets/img/ico-rate-down.svg?react'
import RatingUpIcon from '@/assets/img/ico-rate-up.svg?react'
import KivIcon from '@/assets/img/bxs-show.svg?react'
import JobsOpen from '@/assets/img/ico-open-jobs.svg?react'
import JobsTotal from '@/assets/img/jobs-total.svg?react'
import JobsClose from '@/assets/img/ico-closed-job.svg?react'
import TrendChart from '@/compoments/charts/TrendChart'

import { OrderStatistics } from '@/types/tenant/workGroup.types'

interface JobStatistics {
    label: string
    icon: ReactNode
    trend: 'up' | 'down'
    value: number
    percent: number
}

const JobStatistics = ({ data }: { data?: OrderStatistics }) => {
    const jobStatistics: JobStatistics[] = [
        {
            label: 'Jobs',
            icon: <JobsTotal />,
            trend: Number(data?.total?.changed) >= 0 ? 'up' : 'down',
            value: data?.total?.value || 0,
            percent: Number(data?.total?.changed) || 0,
        },
        {
            label: 'Open Jobs',
            icon: <JobsOpen />,
            trend: Number(data?.open?.changed) >= 0 ? 'up' : 'down',
            value: data?.open?.value || 0,
            percent: Number(data?.open?.changed) || 0,
        },
        {
            label: 'KIV Jobs',
            icon: <KivIcon />,
            trend: Number(data?.kiv?.changed) >= 0 ? 'up' : 'down',
            value: data?.kiv?.value || 0,
            percent: Number(data?.kiv?.changed) || 0,
        },
        {
            label: 'Closed Jobs',
            icon: <JobsClose />,
            trend: Number(data?.closed?.changed) >= 0 ? 'up' : 'down',
            value: Number(data?.closed?.value) || 0,
            percent: Number(data?.closed?.changed) || 0,
        },
    ]
    return (
        <div className="col-12">
            <div className="row gutters-18">
                {jobStatistics.map((item, index) => (
                    <div
                        key={index}
                        className="col-xl-3 col-md-6 col-12"
                    >
                        <div className="card card-shadow card-seo">
                            <div className="card-body">
                                <div className="card-seo-info flex-shrink-0">
                                    <div className="seo-title">
                                        <span className="ico">{item.icon}</span>
                                        <span className="name">
                                            {item.label}
                                        </span>
                                    </div>
                                    <h1 className="seo-stat-title">
                                        {item.value}
                                    </h1>
                                </div>
                                <div
                                    className="card-seo-chart"
                                    style={{
                                        height: 60,
                                        width: 100,
                                    }}
                                >
                                    <TrendChart trend={item.trend} />
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="seo-rating-row">
                                    <div
                                        className={clsx(
                                            'seo-rating',
                                            `--${item.trend}`,
                                        )}
                                    >
                                        <span className="ico">
                                            {item.trend === 'up' ? (
                                                <RatingUpIcon />
                                            ) : (
                                                <RatingDownIcon />
                                            )}
                                        </span>{' '}
                                        <span>
                                            {item.trend === 'up' ? '+' : '-'}
                                            {item.percent}%
                                        </span>
                                    </div>
                                    <p className="seo-rating-desk">
                                        <span>vs</span> yesterday
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default JobStatistics
